import * as moment from 'moment';

export default function (date) {
  let weekInYearIndex = date.week();
  if (date.year() !== date.weekYear()) {
    weekInYearIndex = date.clone().subtract(1, 'week').week() + 1;
  }
  return weekInYearIndex - moment(date).startOf('month').week() + 1;
}
